import { tv } from "tailwind-variants";
import { t } from "ttag";

const styles = tv({
  slots: {
    root: "flex items-center gap-1",
    timeUnit: "flex flex-col items-center",
    value: "text-sm leading-3.5 font-semibold",
    label: "text-xs",
    separator: "text-sm font-semibold",
  },
});

const { root, timeUnit, value, label, separator } = styles();

const minutesToDuration = (minutesLeft: number) => {
  const days = Math.floor(minutesLeft / (24 * 60));
  const hours = Math.floor((minutesLeft % (24 * 60)) / 60);
  const minutes = minutesLeft % 60;

  return { days, hours, minutes };
};

export const Countdown = ({ minutesLeft }: { minutesLeft: number }) => {
  const duration = minutesToDuration(minutesLeft);

  return (
    <div className={root()}>
      <div className={timeUnit()}>
        <p className={value()}>
          {duration.days?.toString().padStart(2, "0") ?? "00"}
        </p>

        <p className={label()}>{t`DAYS`}</p>
      </div>

      <p className={separator()}>:</p>

      <div className={timeUnit()}>
        <p className={value()}>
          {duration.hours?.toString().padStart(2, "0") ?? "00"}
        </p>

        <p className={label()}>{t`HOURS`}</p>
      </div>

      <p className={separator()}>:</p>

      <div className={timeUnit()}>
        <p className={value()}>
          {duration.minutes?.toString().padStart(2, "0") ?? "00"}
        </p>

        <p className={label()}>MIN</p>
      </div>
    </div>
  );
};
